import "core-js/modules/es6.object.to-string.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import * as types from './types';
import fetchProductList from '~/services/layer';
import { fetchProducts as _fetchProducts } from '~/services/product';
import { FAST_TIMER } from '~/const/timers';

function timer() {
  return _timer.apply(this, arguments);
}

function _timer() {
  _timer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                resolve();
              }, FAST_TIMER);
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _timer.apply(this, arguments);
}

export default {
  fetchProducts: function fetchProducts(store, payload) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currentState, productList, products;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit(types.SET_LOADING_LAYER, true);
              currentState = store.state;

              if (!payload.security) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return timer();

            case 5:
              if (!(payload.payload !== currentState.latest)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return fetchProductList(_this, payload.payload);

            case 9:
              productList = _context.sent;
              _context.next = 12;
              return _fetchProducts(_this, productList);

            case 12:
              products = _context.sent;

              if (!(payload.payload !== currentState.latest)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return");

            case 15:
              store.commit(types.SET_LAYER_PRODUCTS, products);
              productList = null;
              products = null;
              store.commit(types.SET_LOADING_LAYER, false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  resetProducts: function resetProducts(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref.commit;
              commit(types.RESET_LAYER_PRODUCTS, []);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  setCurrentLayer: function setCurrentLayer(store, payload) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = payload;
              store.commit(types.SET_CURRENT_LAYER, data);
              data = null;

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  appendItems: function appendItems(store, payload) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              store.commit(types.APPEND_ITEMS, payload);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};